var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"h2 text-center"},[_vm._v(" "+_vm._s(_vm.labels.title)+" ")]),_c('div',[_vm._v("To be implemented")])])
}
var staticRenderFns = []

export { render, staticRenderFns }